import React from "react";

export const GlobalFilter = ({ filter, setFilter, placeholder }) => {
    return (
        <div className="d-flex align-items-center">
            Search
            <input
                className="ms-2 input-search form-control"
                style={{ width: "80%" }}
                value={filter || ""}
                placeholder={placeholder ?? ""}
                onChange={(e) => setFilter(e.target.value.trim())}
            />
        </div>
    );
};